<div class="ids-mb-4 ids-mt-10">
  <p class="ids-mb-4 ids-label -bold ids-color-text-heading-1">percentual dos demais vendedores</p>

</div>


<ids-list class="ids-pb-10">
  <ol>
    <li *ngFor="let item of displaySellers" idsLi>
      <ids-icon idsLiIcon [variant]="item.isFilled ? 'success' : ''">
        {{ item.isFilled ? 'confirmacao' : 'aviso_outline' }}
      </ids-icon>

      <span idsLiText>{{ item.name }}</span>
      <span idsLiSubText>    <span  *ngIf="item.percentage !== undefined && item.type !== 'PJ'">receberá {{ item.percentage }}%</span>

      <ng-container *ngIf="item.additional && item.additional.length > 0">
        <ng-container *ngFor="let additional of item.additional">
          <span >{{ additional.name }}</span>
        </ng-container>
      </ng-container></span>



    </li>
  </ol>


</ids-list>
